import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';

import { Subject } from 'rxjs/Subject';
import { map } from 'rxjs/operators/map';
import { takeUntil } from 'rxjs/operators/takeUntil';

import { AuthService } from '../../services/authentication/auth.service';
import { SplashService } from '../../services/splash/splash.service';

@Component({
    selector: 'app-sso-login',
    styleUrls: ['ssologin.component.css'],
    templateUrl: 'ssologin.component.html',
})
export class SSOLoginComponent implements OnDestroy, OnInit {
    private _subrelease: Subject<void> = new Subject<void>();

    constructor(private authService: AuthService, private route: ActivatedRoute, private router: Router) {}

    ngOnDestroy() {
        this._subrelease.next();
        this._subrelease.complete();
    }

    ngOnInit() {
        const self = this;

        // Listen for the parameters
        self.route.queryParamMap
            .pipe(
                takeUntil(self._subrelease),
                map(params => {
                    return {
                        Data: params.get('data'),
                        IV: params.get('iv'),
                    };
                })
            )
            .subscribe(ssoinfo => {
                // There must be a packet (which is the encoded JSON Focus user object), and an IV token.
                // If either is missing, redirect to the standard login page.
                if (!ssoinfo || !ssoinfo.Data || !ssoinfo.IV) {
                    // Something is missing. Redirect to usual login route.
                    self.router.navigate(['/login']);

                    return;
                }

                // Decode both pieces, and send to the auth controller for SSO login.
                const decodedIV = decodeURIComponent(ssoinfo.IV);
                const decodedPacket = decodeURIComponent(ssoinfo.Data);

                // Grab the screen and window resolutions
                const scr = window.screen.width + 'x' + window.screen.height;
                const win = window.innerWidth + 'x' + window.innerHeight;

                // Pass to the Focus SSO Login routine
                self.authService.FocusSSOLogin(decodedIV, decodedPacket, scr, win).subscribe(
                    UserInfo => {
                        // Use the returned user info to complete the "login" process.
                        self.authService.ProcessLogin(UserInfo);
                        return;
                    },
                    error => {
                        self.authService.HandleServiceError(error);

                        // Transition to the regular login route
                        self.router.navigate(['/login']);
                    }
                );
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/ssologin/ssologin.component.ts